/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { memo, type ReactNode } from 'react';

import { cssMap, jsx } from '@compiled/react';

import ShapesIcon from '@atlaskit/icon/core/shapes';
import {
	PreviewPanel,
	PreviewPanelBody,
	PreviewPanelHeader,
	PreviewPanelTitle,
} from '@atlassian/preview-panel';
import { usePreviewPanelsActions } from '@atlassian/preview-panels-api';

type Props = {
	url: string;
	iframeUrl: string;
	name: string;
	icon?: ReactNode;
};

const styles = cssMap({
	iframe: {
		width: '100%',
		height: '100%',
		border: 'none',
	},
});

export const IFramePreviewPanel = memo(({ url, iframeUrl, name, icon }: Props) => {
	const { close } = usePreviewPanelsActions();

	return (
		<PreviewPanel>
			<PreviewPanelHeader onClose={close} url={url}>
				<PreviewPanelTitle title={name} icon={icon ?? <ShapesIcon label="" size="small" />} />
			</PreviewPanelHeader>
			<PreviewPanelBody withPadding={false}>
				<iframe src={iframeUrl} css={styles.iframe} title={name} />
			</PreviewPanelBody>
		</PreviewPanel>
	);
});
